


const dataFaqs = [
    {
        id: 1,
        title: 'What is GMGN?',
        text : 'GMGN is an advanced multi-chain trading platform that offers tools like Sniping, Copy Trade, and supports multiple wallets, along with real-time market data.',
        show: ''
    
    },
    {
        id: 2,
        title: 'How do I start trading on GMGN?',
        text : `Visit the GMGN website or Telegram bot, connect via your Telegram account, and you'll receive a wallet address to begin trading.`,
        show: ''
    
    },
    {
        id: 3,
        title: 'Which blockchain networks does GMGN support?',
        text : 'GMGN supports trading on Solana, Ethereum, Binance Smart Chain, and TRON',
        show: ''
    
    },
    {
        id: 8,
        title: 'How do I sell tokens on GMGN?',
        text : 'Navigate to the trading page, select the token you wish to sell, enter the amount, and confirm the transaction to sell your tokens.',
        show: ''
    
    },
    {
        id: 4,
        title: 'How can I deposit funds into my GMGN account?',
        text : 'aSelect the wallet you wish to deposit into, copy the wallet address, and transfer funds from your personal wallet.',
        show: ''
    
    },
    {
        id: 5,
        title: 'Does GMGN charge trading fees?',
        text : 'GMGN may apply trading fees depending on the type of transaction and the blockchain network used. Please refer to our fee schedule on the website for more details.',
        show: ''
    
    },
    {
        id: 6,
        title: 'How do I use the Sniping feature on GMGN?',
        text : 'Choose the token you wish to purchase, set your transaction parameters, and activate the Sniping feature to buy tokens as they are launched',
        show: ''
    
    },
    {
        id: 7,
        title: 'Does GMGN offer Copy Trade functionality?',
        text : 'Yes, GMGN provides a Copy Trade feature that allows you to replicate the trading strategies of successful investors',
        show: ''
    
    },
    


   

   
]

export default dataFaqs;